import { httpBatchLink } from '@trpc/client'
import { getWebEnvironment } from '@/lib/config/environment'
import { trpc } from '@/lib/trpc'

export function createTrpcClient() {
  const env = getWebEnvironment()

  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${env.VITE_API_URL.replace(/\/$/, '')}/api`,
        fetch(url, options) {
          return fetch(url, {
            ...options,
            credentials: 'include',
            headers: {
              ...options?.headers,
              'X-Request-ID': crypto.randomUUID(),
            },
          })
        },
      }),
    ],
  })
}
